export default "__VITE_ASSET__Vkp8waM6__"